import axios from "axios";
import { getCurrentCompanyProfile } from "services/companyProfile";
/**
 * Action creator type constants for company info
 */
export const COMPANY_INFO_REQUEST = "COMPANY_INFO_REQUEST";
export const COMPANY_INFO_REQUEST_ERROR = "COMPANY_INFO_REQUEST_ERROR";
export const COMPANY_INFO_REQUEST_SUCCESS = "COMPANY_INFO_REQUEST_SUCCESS";
export const COMPANY_INFO_UPDATE_USERS = "COMPANY_INFO_UPDATE_USERS ";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/billing`;
//const BASE_URL = "http://localhost:8082";

const config = {
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
};

export const updateUsers = (users) => {
  return {
    type: COMPANY_INFO_UPDATE_USERS,
    users,
  };
};

/**
 * Action creator for initiating a company request
 */
function companyRequest() {
  return {
    type: COMPANY_INFO_REQUEST,
    isFetching: true,
  };
}

/**
 * Action creator for signaling a company request error
 * @param error
 */
function companyRequestError({ error }) {
  return {
    type: COMPANY_INFO_REQUEST_ERROR,
    isFetching: false,
    error,
  };
}

/**
 * Action creator for signaling a company request success
 * @param response
 */
function companyRequestSuccess({ addressPreferences, customer, intacctId }) {
  return {
    type: COMPANY_INFO_REQUEST_SUCCESS,
    isFetching: false,
    error: null,
    addressPreferences,
    customer,
    intacctId,
  };
}

/**
 * Exported function exposing an interface used to call company info request API
 */
export function getCompanyInfo(id = null) {
  return (dispatch) => {
    dispatch(companyRequest());
    const companyProfile = getCurrentCompanyProfile();
    let needCompanySwitch = false;

    if (id && companyProfile) {
      if (id !== companyProfile?.IntacctId) {
        needCompanySwitch = true;
      }
    }
    if (!needCompanySwitch && companyProfile) {
      dispatch(companyRequestSuccess(companyProfile));
    }

    if ((!companyProfile && id) || (needCompanySwitch && id)) {
      companyApiRequest(id)
        .then((response) => {
          if (response.status !== 200 || response.data.error) {
            dispatch(companyRequestError(response.data));
          } else {
            dispatch(companyRequestSuccess(response.data));
          }
        })
        .catch(() => {
          dispatch(companyRequestError("Endpoint not resolving."));
        });
    }
  };
}

function companyApiRequest(orgId) {
  if (orgId) {
    const url = `${BASE_URL}/${orgId}/profile`;

    return axios.get(url, config);
  }
}
